import { render } from "./LakalaPayment.vue?vue&type=template&id=4b1545c8&scoped=true"
import script from "./LakalaPayment.vue?vue&type=script&lang=js"
export * from "./LakalaPayment.vue?vue&type=script&lang=js"

import "./LakalaPayment.vue?vue&type=style&index=0&id=4b1545c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1545c8"]])

export default __exports__